import $ from 'jquery';

class Wysiwyg {
    constructor() {
        const wys = document.querySelectorAll('.wysiwyg');
        wys.forEach((wy) => {
            const tables = wy.querySelectorAll('table');
            tables.forEach((table) => {
                // Tạo thẻ div mới
                const wrapper = document.createElement('div');
                wrapper.classList.add('table-wrapper'); // Thêm class nếu cần

                // Đặt table vào bên trong div
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            });

            const ps = wy.querySelectorAll('p');
            ps.forEach((p) => {
                if (p.innerHTML.replace(/&nbsp;|\s/g, "") === "") {
                    p.classList.add('no-margin');
                }
            })
        });

        this.wrappedTextHandle();
    }

    wrappedTextHandle = () => {
        const _this = this;
        
        const wrappedTexts = document.querySelectorAll('.wrapped-text');
        wrappedTexts.forEach(function (container) {
            const MAX_WORDS = container.dataset.maxwords ? container.dataset.maxwords : 40;
            const paragraphs = Array.from(container.children);
            const fullText = paragraphs.map(p => p.textContent.trim()).join(" ");
            const words = fullText.split(/\s+/);

            let wordCount = 0;
            let shortHTML = "";
            let stop = false;

            for (const el of paragraphs) {
                if (stop) break;
                const clone = el.cloneNode(true);
                const words = clone.innerHTML.split(/\s+/);

                if (wordCount + words.length > MAX_WORDS) {
                    const remaining = MAX_WORDS - wordCount;
                    clone.innerHTML = words.slice(0, remaining).join(" ") + "...";
                    stop = true;
                }

                wordCount += words.length;
                shortHTML += clone.outerHTML;
            }

            if (words.length <= MAX_WORDS) return;

            // const truncated = words.slice(0, MAX_WORDS).join(" ") + "...";
            const originalHTML = container.innerHTML;

            container.innerHTML = `
                <div class="short-text">${shortHTML}</div>
                <div class="full-text">${originalHTML}</div>
                <button class="mt-w4p readmore-btn inline-block text-main2 font-semibold">${container.dataset.readmore}</button>
            `;

            const btn = container.querySelector(".readmore-btn");
            const shortText = container.querySelector(".short-text");
            const fullTextDiv = container.querySelector(".full-text");
            _this.jquerySlideUp(fullTextDiv, 0);

            btn.addEventListener("click", () => {
                const expanded = btn.classList.toggle("expanded");
                if (expanded) {
                    shortText.classList.add("hidden");
                    _this.jquerySlideDown(fullTextDiv);
                    btn.remove();
                } else {
                    shortText.classList.remove("hidden");
                    _this.jquerySlideUp(fullTextDiv);
                }
            });
        })
    }

    jquerySlideDown(element, duration = 250) {
        $(element).stop(true, true).slideDown(duration);
    }

    jquerySlideUp(element, duration = 250) {
        $(element).stop(true, true).slideUp(duration);
    }
}

export default Wysiwyg;
